<template>
  <div>
    {{ transport==='air'?'4': '6' }}才/40kg內 （1才=長*寬*高/27000)
  </div>
</template>
<script>
export default {
  props: {
    transport: String,
  }
}
</script>
